import React from 'react';

import StaticAgreement from './StaticAgreement';
import CustomInviteAgreement from './CustomInviteAgreement';

import './style.scss';

export default function Agreement(props) {
  const isGuestUser = Boolean(props.isGuestUser || props.guestUser);

  if (props.useCustomInviteTerms) {
    return (
      <CustomInviteAgreement
        onAgreementAccepted={props.onAgreementAccepted}
        isGuestUser={isGuestUser}
        termsClientId={props.termsClientId}
      />
    );
  }

  return (
    <StaticAgreement
      onAgreementAccepted={props.onAgreementAccepted}
      history={props.history}
      isGuestUser={isGuestUser}
    />
  );
}
